var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBackToHome = function SvgBackToHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.236 3.773 11.906 8.87a.41.41 0 0 1 .084.574l-1.47 1.975a.41.41 0 0 1-.574.083l-9.946-7.408a.41.41 0 0 0-.49 0l-9.928 7.398a.41.41 0 0 1-.573-.083l-1.472-1.974a.411.411 0 0 1 .084-.575l11.889-8.86a.413.413 0 0 1 .49 0Zm3.184 16.843a.41.41 0 0 0 .41-.41v-2.77a.41.41 0 0 0-.41-.41h-2.008a.41.41 0 0 0-.41.41v2.77c0 .226.183.41.41.41h2.008Zm0 5.64a.41.41 0 0 0 .41-.41v-2.769a.41.41 0 0 0-.41-.41h-2.008a.41.41 0 0 0-.41.41v2.77c0 .226.183.41.41.41h2.008Zm-4.88-5.64a.41.41 0 0 0 .41-.41v-2.77a.41.41 0 0 0-.41-.41h-2.01a.41.41 0 0 0-.41.41v2.77c0 .226.184.41.41.41h2.01Zm0 5.64a.41.41 0 0 0 .41-.41v-2.769a.41.41 0 0 0-.41-.41h-2.01a.41.41 0 0 0-.41.41v2.77c0 .226.184.41.41.41h2.01Zm1.206-15.77a.41.41 0 0 1 .49 0l8.51 6.34c.104.077.165.2.165.329v10.742a.41.41 0 0 1-.41.411H7.45a.41.41 0 0 1-.41-.41v-10.72c0-.13.061-.252.165-.33l8.54-6.361Z",
    fill: "#FCFAF8"
  })));
};

export default SvgBackToHome;